export const getValue = (name: string, value: any, current: boolean) => {
    switch (name) {
      case "active":
        return current ? false : true;
      default:
        return value;
    }
  };